import { AfterViewInit, ElementRef, EventEmitter, NgZone, } from '@angular/core';
import { ControlValueAccessor, FormBuilder, FormGroup, Validators, } from '@angular/forms';
import { GoogleMapsService } from '../../services/google.maps.service';
var CitySelectorComponent = /** @class */ (function () {
    function CitySelectorComponent(googleMapService, formBuilder, zone) {
        this.googleMapService = googleMapService;
        this.formBuilder = formBuilder;
        this.zone = zone;
        this.addressValue = '';
        this.disabled = false;
        this.type = 'float';
        this.searchType = 'cities';
        this.placeholder = '';
        this.innerLabel = false;
        this.onAddressClear = new EventEmitter();
        this.locationFormGroup = this.formBuilder.group({
            'address': [null, [Validators.required]],
        });
    }
    Object.defineProperty(CitySelectorComponent.prototype, "value", {
        get: function () {
            return this._value;
        },
        set: function (newValue) {
            this._value = newValue;
            this._notifyChange(this._value);
        },
        enumerable: true,
        configurable: true
    });
    CitySelectorComponent.prototype.registerOnChange = function (fn) {
        this._notifyChange = fn;
    };
    CitySelectorComponent.prototype.registerOnTouched = function (fn) { };
    CitySelectorComponent.prototype.writeValue = function (obj) {
        this._value = obj;
        this.addressValue = !!this._value ? this._value.address : null;
    };
    CitySelectorComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        var options = {
            componentRestrictions: { country: ['us', 'pt', 'uk', 'ca'] },
        };
        if (this.searchType === 'geocode') {
            options.types = ['geocode'];
        }
        else {
            options.types = ['(cities)'];
        }
        this.googleMapService.getGoogle().then(function (googleObject) {
            var ele = _this.type === 'float'
                ? _this.inputElement.nativeElement
                : _this.inputElement.input.nativeElement;
            var autoComplete = new googleObject.maps.places.Autocomplete(ele, options);
            autoComplete.addListener('place_changed', function () {
                _this.zone.run(function () {
                    var place = autoComplete.getPlace();
                    if (place.geometry) {
                        var state = '', country = '';
                        if (place.address_components) {
                            var stateComponent = place.address_components.find(function (x) {
                                return x.types.includes('administrative_area_level_1');
                            });
                            if (stateComponent) {
                                state = stateComponent.short_name || stateComponent.shortText;
                            }
                            var countryComponent = place.address_components.find(function (x) {
                                return x.types.includes('country');
                            });
                            if (countryComponent) {
                                country = countryComponent.short_name || countryComponent.shortText;
                            }
                        }
                        _this.value = {
                            lat: place.geometry.location.lat(),
                            lng: place.geometry.location.lng(),
                            address: place.formatted_address,
                            city: place.name,
                            state: state,
                            country: country,
                            placeId: place.place_id,
                        };
                    }
                    else {
                        _this.value = {
                            address: place.name,
                        };
                    }
                });
            });
        });
    };
    CitySelectorComponent.prototype.clear = function () {
        this.addressValue = null;
        this.value = null;
        this.onAddressClear.emit();
    };
    return CitySelectorComponent;
}());
export { CitySelectorComponent };



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/common/components/city.selector/city.selector.component.ts.pre-build-optimizer.js